export const formatWalletAddress = (walletAddress: string) =>
  walletAddress.slice(0, 4) + '*'.repeat(walletAddress.length - 8) + walletAddress.slice(-4)
